import { Checkbox, Label, Box, Text } from '@origin-digital/style-guide';
import React from 'react';

import { CheckboxAdapterProps } from './CheckboxAdapter.types';
import analytics from '../../../../analytics';

const CheckboxAdapter = (props: CheckboxAdapterProps): JSX.Element => {
  const { field, id, label, form } = props;

  const onSelect = (value: boolean): void => {
    form.setFieldValue(field.name, value, false);
  };

  return (
    <Box alignItems="center" direction="row" display="flex">
      <Checkbox
        id={id}
        name={field.name}
        checked={field.value}
        size={'md'}
        onChange={e => {
          onSelect(e.checked);
          if (props.analytics !== false) analytics.checkboxClick(field.name, label, Boolean(e.checked));
        }}
      />
      <Label htmlFor={id}>
        <Box paddingX={2}>
          <Text size={'sm'}>{label}</Text>
        </Box>
      </Label>
    </Box>
  );
};

export { CheckboxAdapter as default };
